/* eslint-disable */
const mutations = {
  updateIsLoading(state, { isLoading }) {
    state.isLoading = isLoading;
  },

  setCheckoutMethod(state, { checkoutMethod }) {
    state.data = checkoutMethod;
  },

  updateCheckoutMethod(state, { checkoutMethod }) {
    state.data = {
      ...state.data,
      ...checkoutMethod,
    };
  },
};

export default mutations;
